import { AutogenLayoutFuelDirectVendor } from "./autogen/AutogenLayoutFuelDirectVendor";
import { ChangeEvent } from "@mcleod/components";

export class FuelDirectVendor extends AutogenLayoutFuelDirectVendor {

    /** This is an event handler for the onChange event of textboxApVoucherType. */
    textboxApVoucherTypeOnChange(event: ChangeEvent) {
        const apVoucherValue = event.newValue;
        const showFields = apVoucherValue === "Manual" || apVoucherValue === "Regular";
        this.textboxApDivId.setProps({ visible: showFields, required: showFields });
        this.textboxApVendorId.setProps({ visible: showFields, required: showFields });
        this.textboxApGlid.setProps({ visible: showFields, required: showFields });
    }

}
